<template>
  <vs-row
    class="p-3 mt-2 shadow-sm bg-white"
  >
    <vs-col vs-lg="11">
      <vs-row>
        <vs-col class="text-center text-primary" vs-lg="1">
          <div :class="{ 'text-success': wasCopied }">
            # <br>
          </div>
          <div
            :class="{ 'text-success': wasCopied }"
            class="cursor-pointer"
            @click="copyToClipboard(file.id)"
          >
            {{ file.id }}
          </div>
        </vs-col>
        <vs-col vs-lg="2">
          {{ file.theme }}
        </vs-col>
        <vs-col vs-lg="9">
          <vs-row>
            <vs-col vs-lg="2" vs-sm="3" vs-xs="12">
              {{ file.typeDescription }}
            </vs-col>
            <vs-col vs-lg="2" vs-sm="3" vs-xs="12">
              {{ file.folio }}
            </vs-col>
            <vs-col
              v-if="$route.params.view === 'salientes'"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
              class="px-2"
            >
              {{
                withCopyEntity.length > 1
                  ? 'Según distribución'
                  : withCopyEntity[0].entidadNombre
              }}
            </vs-col>
            <vs-col v-else vs-lg="3" vs-sm="3" vs-xs="12" class="px-2">
              {{file.creatorEntityName}}
            </vs-col>
            <vs-col vs-lg="3" vs-sm="3" vs-xs="12">
              {{file.createdAt}}
            </vs-col>
            <vs-col vs-lg="2" vs-sm="3" vs-xs="12">
              {{file.creatorName}}
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-col>
    <vs-col vs-lg="1" vs-type="flex" vs-justify="center" vs-align="center">
      <FileOptions
        :file="file" :select-file="selectFile"
        @refresh-list="refreshList"
      />
    </vs-col>
  </vs-row>
</template>

<script>
import FileOptions from '@/febos/chile/docDigital/components/FileOptions';
import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';

export default {
  mixins: [CopyToClipboard],
  components: {
    FileOptions
  },
  props: [
    'file',
    'selectFile',
    'refreshList'
  ],
  computed: {
    withCopyEntity() {
      const entitiesMap = this.file.withCopy.entidades.map((item) => [item.entidadId, item]);
      const entitiesMapArr = new Map(entitiesMap);

      return [...entitiesMapArr.values()];
    }
  }
};

</script>
